(function () {
  function initGallery(gallery) {
    if (gallery.dataset.adjGalleryReady) return;
    gallery.dataset.adjGalleryReady = 'true';

    const mainImage = gallery.querySelector('[data-adj-main-image]');
    const zoomTrigger = gallery.querySelector('[data-adj-zoom-open]');
    const thumbnails = gallery.querySelectorAll('[data-adj-thumbnail]');
    const lightbox =
      (gallery.nextElementSibling && gallery.nextElementSibling.matches('[data-adj-lightbox]')
        ? gallery.nextElementSibling
        : null) ||
      gallery.parentElement?.querySelector('[data-adj-lightbox]') ||
      document.querySelector('[data-adj-lightbox]');

    if (!mainImage || !zoomTrigger || !lightbox) return;

    const lightboxContent = lightbox.querySelector('[data-adj-lightbox-content]');
    const closeButton = lightbox.querySelector('[data-adj-zoom-close]');
    const lightboxImages = lightbox.querySelectorAll('[data-media-id]');

    function setActiveMedia(mediaId) {
      zoomTrigger.setAttribute('data-media-id', mediaId);

      lightboxImages.forEach((img) => {
        img.classList.toggle('active', img.getAttribute('data-media-id') === String(mediaId));
      });

      thumbnails.forEach((thumb) => {
        const isActive = thumb.getAttribute('data-media-id') === String(mediaId);
        thumb.classList.toggle('active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function openLightbox() {
      const mediaId = zoomTrigger.getAttribute('data-media-id');
      setActiveMedia(mediaId);

      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }

      document.body.classList.add('overflow-hidden');

      requestAnimationFrame(() => {
        const activeImage = lightbox.querySelector('.adj-product-lightbox__image.active');
        if (activeImage && lightboxContent) {
          activeImage.scrollIntoView({ block: 'start' });
        }
      });
    }

    function closeLightbox() {
      if (typeof lightbox.close === 'function' && lightbox.open) {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.body.classList.remove('overflow-hidden');
    }

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        const srcset = thumb.getAttribute('data-srcset');
        const alt = thumb.getAttribute('data-alt');
        const mediaId = thumb.getAttribute('data-media-id');

        // Clear srcset/sizes first so the browser does not keep the previous currentSrc
        const sizes = mainImage.getAttribute('sizes');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        if (src) mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        if (sizes) mainImage.sizes = sizes;
        if (alt) mainImage.alt = alt;

        setActiveMedia(mediaId);
      });
    });

    zoomTrigger.addEventListener('click', openLightbox);

    if (closeButton) {
      closeButton.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    lightbox.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
    });

    lightbox.addEventListener('cancel', () => {
      document.body.classList.remove('overflow-hidden');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-adj-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
